import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getApprovedApplication, dofApprovals, getRegionPresident } from "../../../api/apiServices";
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'

const ApprovalForm = (props) => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);


    const params = useParams();
    const id = parseInt(params.id)

    const [application, setApplication] = useState([]);
    const [region_president, setRegionPresident] = useState("");
    const [approve_type, setApproveType] = useState("");

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        if (id) {
            getApprovedApplication(id, { signal })
                .then((data) => {
                    console.log(data[0])
                    setApplication(data)
                    getRegionPresident(data[0].region_code).then(setRegionPresident);
                });
        } else {
            setApplication([]);
        }
        return () => {
            controller.abort();
        };
    }, [id])

    let total_applications = application?.length
    
    let dof_approved_status = false
    let application_id = "";
    let date_of_birth = "";
    const memPayment = []

    for (var i = 0; i < application.length; i++) {
        application_id = application[i].id;
        date_of_birth = application[i].date_of_birth;
        const memPayments = application[i].payments

        for (var j = 0; j < memPayments.length; j++) {
            let payload = {
                year: memPayments[j].year,
                payment_date: memPayments[j].payment_date,
                payment_code: memPayments[j].payment_code,
                receipt_number: memPayments[j].receipt_number,
                description: memPayments[j].description,
                payment_amount: memPayments[j].payment_amount
            }
            memPayment.push(payload)
        }
    }

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/dof_approvals";

    const handleOptionChange = (e) => {
        e.preventDefault();
        setApproveType(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (approve_type === 'Approved') {
            dof_approved_status = true;
        }
        const data = {
            "application_id": application_id,
            "dof_approved_status": dof_approved_status,
            "dof_approval_rejection_reason": approve_type,
        }
        dofApprovals(data).then((res) => {
            toast.success("Member successfully approved ");
            setApplication([])
            navigate(from, { replace: true });
        })
    }
    const handleCancel = (e) => {
        e.preventDefault();
        navigate(from, { replace: true });
    }

    return (
        <section className='main-container'>
            <Toaster toastOptions={{ position: "top-center" }} />
            <h2 className="heading">Applications : Pending Final Approval - {total_applications}</h2>
            <div className="box-body">
                <div className="data-table">
                    <legend style={{ fontSize: "24px", fontWeight: "700", color: "white" }}>Applicant Information</legend>
                    <table className="table table-borderless">
                        <tbody>
                            {application?.map((application, index) =>

                                <><tr key={index}>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>PF Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{application.pf_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.ndc_applicationship_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.voter_id_number}</td>
                                </tr><tr>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.last_name}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.first_name}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.middle_name}</td>
                                    </tr><tr>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.email}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Phone Number</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.mobile_number}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.gender}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.region}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.constituency}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.branch}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Recommended By</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{application.recommended_by}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={6}>
                                            <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Regional President Information</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Name</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president.fullname}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Phone Number</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president.mobile_number}</td>
                                        <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                        <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president.email}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3}>
                                            <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Regional Approval Information</strong>
                                        </td>
                                        <td colSpan={3}>
                                            <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}><a rel="noreferrer" target="_blank" href="https://www.ndcpayment.com/dues/pay">Click to verify applicant NDC applicationship</a></strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Reason for Approval/Rejection/Escalation</td>
                                        <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "brown", textAlign: "left", whiteSpace: "pre-wrap" }}> 	{application.regional_approval_rejection_reason}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={6}>
                                            <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Director of Operations Approval Information</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Reason for Approval</td>
                                        <td colSpan={3} style={{ fontSize: "16px", fontWeight: "700", color: "brown", textAlign: "left", whiteSpace: "pre-wrap" }}> 	{application.dop_approval_rejection_reason}</td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="data-table">
                    <legend style={{ fontSize: "24px", fontWeight: "700", color: "white" }}>Payment Information</legend>
                    {memPayment.length > 0 ? (
                        <><table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td colSpan={4}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Statutory Payment</strong>
                                    </td>
                                    <td>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>GHC</strong>
                                    </td>
                                </tr>
                            </tbody>
                            {memPayment.map((pay, index) => (
                                pay.payment_code === "ADF" || pay.payment_code === "ASF" || pay.payment_code === "PSL" ? (
                                    <tbody>
                                        <tr key={index}>
                                            <td colSpan={4} style={{ paddingLeft: "5rem", fontSize: "16px", fontWeight: "700", color: "#000b41", textAlign: "left" }}>{pay.description}
                                            </td>
                                            <td colSpan={2} style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", textAlign: "left", whiteSpace: "pre-wrap" }}> {pay.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : ("")
                            ))}
                        </table>
                        </>
                    ) : (
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td colSpan={6}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Applicant has not made the Statutory Payment</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div > <><br /><div className="box-body">
                    <br />
                    <form onSubmit={handleSubmit} className="approval-options">
                        <div className="search-group">
                            <input
                                type="checkbox"
                                value="Approved"
                                // checked={approve_type === 'Approve'}
                                onChange={handleOptionChange}
                                className="input-control" />
                            <label style={{ fontSize: "14px", fontWeight: "700", color: "white", textAlign: "left", whiteSpace: "pre-wrap" }} htmlFor="pf_number" className="label-name">&nbsp;&nbsp;APPROVE APPLICATION
                            </label>
                        </div>
                        <div className="search-group">
                            <div className="col-sm-5">
                                <button className="btn btn-success"> Submit</button>
                            </div>
                            <div className="col-sm-5">
                                <button className="btn btn-danger" onClick={handleCancel}> Cancel</button>
                            </div>
                        </div>
                    </form>
                </div><div>
                        <div style={{ height: '5rem' }} />
                    </div></>
            </div >
        </section >
    );
}

export default ApprovalForm;